import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { RegistrationPaths } from '@gipi-paths/registration.paths';
import { AbstractCrudService, FilterDTO } from '@gipisistemas/ng-core';
import { RegistrationCompany } from '../models/company.model';

@Injectable({ providedIn: 'root' })
export class RegistrationCompanyService extends AbstractCrudService<RegistrationCompany, FilterDTO> {

    constructor(http: HttpClient) {
        super(RegistrationPaths.company, http);
    }

    findByIdIn(idList: number[]): Observable<RegistrationCompany[]> {
        return this.http.post(this.url('find-by-ids'), idList, this.options()).pipe(
            map(this.mapper),
            catchError(this.handleError)
        );
    }
}
